// extracted by mini-css-extract-plugin
module.exports = {"header":"a10a3f92e9--header--PCyut","counter":"a10a3f92e9--counter--j1yat","content":"a10a3f92e9--content--gFhtt","close_button":"a10a3f92e9--close_button--dvuSM"};